/**
 * English resource bundle — required for MVP (PRD §2.5 BR-I18N-01).
 * All UI strings must come through here, never hardcoded.
 */
export const en = {
  common: {
    cancel: 'Cancel',
    save: 'Save',
    delete: 'Delete',
    edit: 'Edit',
    close: 'Close',
    back: 'Back',
    next: 'Next',
    loading: 'Loading…',
    skip: 'Skip',
    confirm: 'Confirm',
    retry: 'Retry',
  },
  auth: {
    signIn: 'Sign in',
    signUp: 'Create your account',
    signOut: 'Sign out',
    emailLabel: 'Email',
    passwordLabel: 'Password',
    forgotPassword: 'Forgot password?',
    noAccount: 'New to InkFinity?',
    haveAccount: 'Already have an account?',
    createAccount: 'Create account',
    continueWithGoogle: 'Continue with Google',
    continueWithGitHub: 'Continue with GitHub',
    orSignUpWithEmail: 'or sign up with email',
    agreeTermsPrefix: 'I agree to the',
    termsOfService: 'Terms of Service',
    and: 'and',
    privacyPolicy: 'Privacy Policy',
    passwordHint: 'Min 8 chars, with uppercase, lowercase, and a number.',
    invalidEmail: 'Please enter a valid email address.',
    weakPassword: 'Password must include an uppercase letter and a number.',
    termsRequired: 'You must agree to the terms.',
  },
  chat: {
    newChat: 'New chat',
    sendPlaceholder: 'Write a prompt, paste a file, or pick an idea above…',
    replyPlaceholder: 'Reply or attach…',
    emptyHeadline: 'Where would you like to begin?',
    emptyBody: "Start a conversation. We'll figure out the rest together.",
    modeAgent: 'Agent',
    modePlan: 'Plan',
    modeAsk: 'Ask',
    streaming: 'Generating…',
    pause: 'Pause generation',
    resume: 'Resume generation',
    readOnlyBadge: 'Read-only',
    planReady: 'Plan ready for review',
    approvePlan: 'Approve & execute',
    editPlan: 'Edit plan',
  },
  files: {
    dropzoneTitle: 'Drop files here',
    dropzoneSub: '…or click to browse. AI will read and cite anything you upload.',
    chooseFiles: 'Choose files',
    uploadLimit: 'Up to {size} per file · {count} files at a time · {total} total',
    uploadSuccess: 'Uploaded {count} files',
  },
  errors: {
    generic: 'Something went wrong. Please try again.',
    network: 'Network error. Check your connection.',
    rateLimited: 'Too many requests. Please wait a moment.',
    fileTooLarge: 'File too large — exceeds the {limit} limit',
    unsupportedFormat: 'Format not supported',
    virusDetected: 'Blocked by virus scan',
  },
  settings: {
    profile: 'Profile',
    password: 'Password',
    language: 'Language',
    memory: 'Memory',
    plan: 'Plan & billing',
    dataExport: 'Export your data',
    deleteAccount: 'Delete account',
    deleteConfirmPhrase: 'delete my account',
  },
  a11y: {
    skipToMain: 'Skip to main content',
    closeMenu: 'Close menu',
    openMenu: 'Open menu',
    loadingAnnouncement: 'Loading, please wait',
    errorAnnouncement: 'Error: {message}',
  },
} as const;

export type EnMessages = typeof en;
